import { CreateButton } from "@refinedev/antd";
import { ComponentProps, ReactNode } from "react";
import { Grid } from "antd";
import { FileVideoIcon } from "@phosphor-icons/react";
import { radius } from "@libertify/ui";

interface CreatePrimaryButtonProps extends ComponentProps<typeof CreateButton> {
  children: ReactNode;
}
export const CreatePrimaryButton = ({
  children,
  textStyle,
  ...props
}: CreatePrimaryButtonProps & { textStyle?: React.CSSProperties }) => {
  const breakpoint = Grid.useBreakpoint();
  return (
    <CreateButton
      {...props}
      icon={<FileVideoIcon size={20} />}
      style={{
        padding: "8px 16px",
        borderRadius: radius.pill,
        height: 40,
        fontSize: breakpoint.xxl ? 14 : undefined,
        ...props.style,
      }}
    >
      <span
        style={{
          ...textStyle,
        }}
      >
        {children}
      </span>
    </CreateButton>
  );
};
